export class StudentCourseAddResponseModel {
	class_id: number;
	success: boolean;
	teacher_id?: number;
	registration_id?: number;
	message?: string;
	rebuild_acknowledgement_required?: boolean;
	access_grant_successful?: boolean;
}
